"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoViewMode;
(function (VideoViewMode) {
    VideoViewMode["REGULAR"] = "REGULAR";
    VideoViewMode["BLUR"] = "BLUR";
    VideoViewMode["FILL"] = "FILL";
})(VideoViewMode || (VideoViewMode = {}));
exports.VideoViewMode = VideoViewMode;
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/screen/types.js
// module id = 26
// module chunks = 0